import DeviceData from './DeviceData';
import DeviceItem from './DeviceItem';

function HeatExchangerDevice(props) {
	return <DeviceItem {...props} data={DeviceData.HEAT_EXCHANGER} />;
}

export default HeatExchangerDevice;
